import videojs from "video.js";
import "../../components/radio-button/radio-button.js";
import { checkTouchScreen } from "../../js/helpers/checkTouchScreen.js";

const Component = videojs.getComponent('Component');

class GroupWithQualityModalMenu extends Component {
	constructor(player, options) {
		super(player, options);

		this.hide();

		this.qualityList = [];

		this.currentSelectedRadioButton = undefined;

		this.addClass('vjs-group-with-quality__modal-menu');
		if (checkTouchScreen()) {
			this.addClass('vjs-group-width-quality__modal-menu_touch');
		}

		this.contentContainer = this.addChild('Component');
		this.contentContainer.addClass('vjs-group-with-quality__content-container');
		this.contentContainer.addClass('vjs-custom-scrollbar');


		// Add container with qualities
		this.qualitiesContainer = this.contentContainer.addChild('Component');
		this.qualitiesContainer.addClass('vjs-group-with-quality__qualities-container');

		// Add qualities title
		const title = this.qualitiesContainer.addChild('Component');
		title.el().innerText = 'качество';
		title.addClass('vjs-group-with-quality__title');

		// Add qualities container
		this.qualitiesList = this.qualitiesContainer.addChild('Component');

		if (!this.options_.isLive) {
			// Add qualities spacer
			const spacer = this.qualitiesContainer.addChild('Spacer');
			spacer.addClass('vjs-group-with-quality__spacer');

			// Add qualities button 'Скорость'
			const updateButtonValue = (button, value) => {
				button.$('.vjs-control-text').setAttribute('data-value', `${value}x`);
			};
			const buttonForward = this.qualitiesContainer.addChild('ClickableComponent', {
				clickHandler: () => {
					this.playbackRateContainer.show();
					this.qualitiesContainer.hide();
				}
			});
			buttonForward.controlText('Скорость');
			buttonForward.addClass('vjs-button-forward');
			buttonForward.addClass('vjs-button-forward_speed');
			updateButtonValue(buttonForward, this.player().playbackRate());
			this.player().on('ratechange', () => {
				updateButtonValue(buttonForward, this.player().playbackRate());
			});

			// Add playback rate container
			this.playbackRateContainer = this.contentContainer.addChild('Component');
			this.playbackRateContainer.hide();
			this.playbackRateContainer.addClass('vjs-group-with-quality__playback-rate-container');

			// Add playback rate button back
			const buttonBack = this.playbackRateContainer.addChild('ClickableComponent', {
				clickHandler: () => {
					this.playbackRateContainer.hide();
					this.qualitiesContainer.show();
				}
			});
			buttonBack.controlText('Назад');
			buttonBack.addClass('vjs-button-back');

			// Add playback rate radio buttons
			const changePlaybackRateButtons = [1, 1.25, 1.5, 1.75, 2].map((rate) => {
				const button = this.playbackRateContainer.addChild('RadioButton', {
					clickHandler: (event) => {
						this.player().playbackRate(button.getAttribute('data-rate'));
					},
					controlText: `${rate}x`
				});
				button.setAttribute('data-rate', rate);
				if (this.player().playbackRate() === rate) {
					button.select();
				}
				return button;
			});
			this.player().on('ratechange', () => {
				changePlaybackRateButtons.forEach((button) => button.unselect());
				const newPlaybackRate = this.player().playbackRate();
				const playbackRateButton = changePlaybackRateButtons.find((button) =>
					button.getAttribute('data-rate') === newPlaybackRate.toString()
				);
				playbackRateButton.select();
			});
		}

		// Update qualities
		const listQualityEvents = ['change', 'change_forced', 'change_selected'];
		this.player().quality_handler.on('native_quality_handler/created', () => {
			this.player().quality_handler.native_quality_handler.on('qualities_initialized', () => {
				this.fillWithQualities();
			});
		});
		this.player().quality_handler.qualities.on(listQualityEvents, () => {
			this.fillWithQualities();
		});
		// в браузере firefox при множественной вставке не появляются элементы качества
		// задержка нужна, чтобы функция срабатывала, когда есть массив объектов качеств
		setTimeout(() => {
			this.fillWithQualities();
		});
	}

	fillWithQualities() {
		this.removeOldQualities();
		this.addNewQualities();
	}

	removeOldQualities() {
		this.currentSelectedRadioButton = this.player().quality_handler.qualities.list.find((quality) => quality.selected);
		this.qualityList.forEach((component) => this.qualitiesList.removeChild(component));
		this.qualityList = [];
	}

	addNewQualities() {
		const player = this.player();
		// Getting Menu through getDescendant don't work
		const menu = player.getDescendant(['controlBar', 'QualitySwitcherButton']).children()[1];
		const qualityComponents = menu && menu.children();
		if (qualityComponents.length === 0) return;
		qualityComponents.forEach((qualityComponent) => {
			const isQualityUnavailable = this.options_.isQualityUnavailable(qualityComponent.quality.name);
			const isQualityRestricted = this.options_.isQualityRestricted(qualityComponent.quality.name);
			/**
			 * Если на качество распространяются ограничения, то оно должно быть недоступным для
			 * выбора со стороны hls.js
			 */
			if (isQualityUnavailable || isQualityRestricted) {
				const unavailableIndex = player.hls_.levels.findIndex(
					level => level.attrs['X-NAME'] === qualityComponent.quality.name
				);
				player.hls_.removeLevel(unavailableIndex);
			}

			/**
			 * Если качество не может стать доступным из-за ограничений, то не отображаем его в
			 * общем списке
			 */
			if (isQualityUnavailable) {
				return;
			}

			const radioButton = this.qualitiesList.addChild('RadioButton', {
				clickHandler: () => {
					if (isQualityRestricted) {
						this.options_.showRestrictionModalDialog(() => {
							this.options_.requestAccess(qualityComponent.quality.name);
						});
						this.options_.hideModal();
						return;
					};

					this.qualityList.forEach((button) => button.unselect());
					radioButton.select();
					qualityComponent.handleClick();
					this.trigger('quality-selected');
				},
				controlText: qualityComponent.quality.label,
				dataAttribute: {
					name: 'data-quality-name',
					value: qualityComponent.quality.name
				}
			});

			if (isQualityRestricted) {
				radioButton.addClass('vjs-radio-button_restricted');
			}

			if (this.currentSelectedRadioButton && this.currentSelectedRadioButton.label === radioButton.controlText()) {
				radioButton.select();
			}
			this.qualityList.push(radioButton);
		});
		const savedUserPreferredQuality = qualityComponents[0].qualities_list.getUserPreferredQuality();
		if (savedUserPreferredQuality && savedUserPreferredQuality.selected) {
			const radioButtonToSelect = this.qualitiesList.children()
				.filter((radioButton) => !radioButton.isDisposed())
				.find((radioButton) => radioButton.controlText() === savedUserPreferredQuality.label);
			if (radioButtonToSelect) {
				radioButtonToSelect.select();
			}
		} else if (!this.currentSelectedRadioButton && !savedUserPreferredQuality) {
			const selectedQuality = qualityComponents.find((quality) => quality.isSelected_)
				|| qualityComponents.find((quality) => quality.quality.auto);
			if (selectedQuality) {
				const radioButtonToSelect = this.qualitiesList.children()
					.filter((radioButton) => !radioButton.isDisposed())
					.find((radioButton) => radioButton.controlText() === selectedQuality.quality.label);
				if (radioButtonToSelect) {
					radioButtonToSelect.select();
				}
			}
		}
		this.trigger('qualities-updated');
	}

	show() {
		super.show();
		// timeout нужен чтобы при одновременном закрытии одного меню и открытии этого добавление класса было после его удаления
		setTimeout(() => {
			this.player().addClass('vjs-showing-settings');
		});
	}

	hide() {
		super.hide();
		this.player().removeClass('vjs-showing-settings');
	}
}

videojs.registerComponent('GroupWithQualityModalMenu', GroupWithQualityModalMenu);
